import { Directive, forwardRef, Injectable } from '@angular/core';
import { NG_VALIDATORS, FormControl, AsyncValidator, ValidationErrors, AbstractControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';



@Injectable()
@Directive({
  selector: '[appExistingEmailValidator][formControlName]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ExistingEmailValidator), multi: true }
  ]
})
export class ExistingEmailValidator implements AsyncValidator {

  validator: Function;

  constructor(private auth: AuthService) {
    this.validator = ExistingEmailValidator.validateEmailFactory(auth);
  }

  validate(c: FormControl): Observable<ValidationErrors | null> {
    return this.validator(c);
  }

  static validateEmailFactory(auth: AuthService) {
    return (c: AbstractControl) => {
      return auth.unique(c.value).pipe(
        map(yes => {
          return yes ? null : { existingEmail: true };
        })
      );

    };
  }
}
